<template>
  <Head title="Pathway - Filter" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <h1 class="m-2">Pathway Filter</h1>
          <pathways-filter :client="client" :destination="destination" :census_connection="census_connection"></pathways-filter>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  destination: Object,
  census_connection: Object
});
</script>

